import { openRearCamera, startScanLoop, stopStream } from '../qr-scanner.js';
import { receivePathFromSharedText } from '../share-target.js';
import { t } from '../i18n/index.js';
import { el } from './dom.js';

/**
 * Full-screen camera view that closes itself as soon as a Sync Port link or PIN is recognised.
 * Anything else in the frame is ignored so an unrelated QR code cannot navigate the user away.
 */
export const openScanOverlay = async (root: HTMLElement): Promise<void> => {
  const video = el('video', { className: 'scan__video' });
  video.setAttribute('playsinline', '');
  video.muted = true;
  const hint = el('p', { className: 'scan__hint', text: t('scan.hint') });
  const cancel = el('button', { className: 'button button--ghost scan__cancel', type: 'button', text: t('action.cancel') });
  const overlay = el('div', { className: 'scan' }, [
    video,
    el('div', { className: 'scan__frame' }),
    hint,
    cancel,
  ]);
  root.append(overlay);

  let stream: MediaStream;
  try {
    stream = await openRearCamera();
  } catch (error) {
    overlay.remove();
    throw error;
  }
  video.srcObject = stream;
  await video.play();

  const close = (): void => {
    loop.stop();
    stopStream(stream);
    overlay.remove();
  };
  const loop = startScanLoop(video, (text) => {
    const path = receivePathFromSharedText(text, window.location.origin);
    if (path === null) {
      hint.textContent = t('scan.notOurs');
      return false;
    }
    close();
    window.location.assign(path);
    return true;
  });
  cancel.addEventListener('click', close);
  window.addEventListener('pagehide', close, { once: true });
};
